import { render, staticRenderFns } from "./RayosX.vue?vue&type=template&id=57e2c6b4&scoped=true&"
import script from "./RayosX.vue?vue&type=script&lang=js&"
export * from "./RayosX.vue?vue&type=script&lang=js&"
import style0 from "./RayosX.vue?vue&type=style&index=0&id=57e2c6b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e2c6b4",
  null
  
)

export default component.exports